import React from 'react';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';
import DialogComponent from '@ui/components/Dialog/Dialog.component';

const Component: React.FC<IProps> = ({
    lang,
    loading,
    login,
    serverError,
    onConfirmClick,
    onCancelClick,
    onBtnKeyDown,
}: IProps) => {
    const getWord = useDictionary();

    return (
        <>
            <DialogComponent
                className="delete-subuser"
                alertText={serverError ? 'serverError' : undefined}
                loading={loading}
                lang={lang}
                title={`${getWord('confirmSubuserDeleteWarning')} "${login}"?`}
                onConfirmClick={onConfirmClick}
                onCancelClick={onCancelClick}
                onBtnKeyDown={onBtnKeyDown}
            />
        </>
    );
};

const DeleteSubuserComponent = React.memo(Component);

export default DeleteSubuserComponent;
